import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { filter, map, switchMap, take, tap } from "rxjs/operators";
import { Building } from "src/components/shared-components/class/general-classes/building";
import { Settings } from "src/model/class/settings";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { ApplicationTheme } from "src/components/shared-components/enum/enumMisc";
import { LoggerService } from "src/service/logger.service";
import { ThemeService } from "src/service/theme.service";
import { isHydrated } from "src/state/hydrate";
import { selectedBuilding } from "src/components/shared-components/state/selectors/building.selector";
import { SystemRouterService } from "../service/system-router.service";
@Injectable({ providedIn: "root" })

/**
 *
 *  La guardia {@link PermissionGuard} controlla l'accesso alle pagine del sistema
 *
 */
export class PermissionGuard  {
  private _logContext: string = "PermissionGuard";
  private currentBuilding: Building;
  constructor(
    private _systemRouterService: SystemRouterService,
    private _router: Router,
    private _store: Store,
    private _themeService: ThemeService,
    private _loggerService: LoggerService
  ) { }

  /**
   * GF: Il metodo {@link canActivate} esegue il costrutto di protezione alle pagine: se l'utente ha il permesso di
   *  visualizzare quella pagina la vede, altrimenti viene rediretto sulla prima pagina a disposizione
   *
   * @param route : parametro di default passato al canActivate
   *
   * @param state : parametro di default passato al canActivate
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Promise<boolean | UrlTree>
    | Observable<boolean | UrlTree> {
    return this.checkIsStoreReady().pipe(
      switchMap(() => {
        return this.checkCurrentBuilding();
      })
    );
  }

  /**
   * Handle can view section
   *
   * @param page
   * @param settingsValue
   * @returns
   */
  private canView(page: string, settingsValue: Settings) {
    let canView = true;
    switch (page) {
      case "supervisions":
        canView = settingsValue.ShowSupervision;
        break;
      case "scenarios":
        canView = settingsValue.ShowSceneAndSchedule;
        break;
      case "schedules":
        canView = settingsValue.ShowSceneAndSchedule;
        break;
      default:
        canView = true;
        break;
    }
    return canView;
  }

  private tmpFunction(): void {
    /*  return this._settingService.settings.pipe(
      filter((setting) => setting !== null),
      switchMap((settingsValue) => {
        let canView = this.canView(route.routeConfig.path, settingsValue);

        if (canView) {
          return of(true);
        } else {
          /**
           * GF: if the selected page can not be loaded search for the first page that can be loaded.
           * If no page can be loaded do logout
           */
    /*      const pages = ["supervisions", "scenarios", "schedules"];
          for (let index = 0; index < pages.length; index++) {
            const page = pages[index];
            if (this.canView(page, settingsValue)) {
              this._router.navigateByUrl("/" + page);
              canView = true;
            }
          }

          if (!canView) {
            //Necessita di ulteriori controlli
            this._systemRouterService.navigateToSystemOptionSettings();

            of(true);
          }
        }
      }),
      catchError((error) => {
        return throwError(error);
      })
    ); */
  }

  /**
   *   This method check if the NgRx store has already been initialised (IE. hydrated) from the local storage.
   * It does so observing the value of the "hydrated" feature.
   * @returns An observable. This Observable shall not emit until the "hydrated" feature changes its value to TRUE.
   */
  private checkIsStoreReady(): Observable<boolean> {
    return this._store.select(isHydrated).pipe(
      tap((isHydrated: boolean) => {
        this._loggerService.log(
          LogLevel.LOG_INFO,
          this._logContext,
          this._logContext,
          " checkIsStoreReady() ",
          "isHydrated: " + isHydrated
        );
      }),
      filter((isHydrated: boolean) => isHydrated),
      tap((isHydrated: boolean) => {
        this._loggerService.log(
          LogLevel.LOG_INFO,
          this._logContext,
          this._logContext,
          " checkIsStoreReady() ",
          "GO AHEAD!"
        );
      }),
      take(1)
    );
  }

  /**
   * Handle if there is current building //
   *
   * @returns
   */
  private checkCurrentBuilding(): Observable<boolean> {
    return this._store.select(selectedBuilding).pipe(
      map((currentBuilding: Building) => currentBuilding),
      switchMap((currentBuilding: Building) => {
        if (currentBuilding?.id) {
          return of(true);
        } else {
          return of(false);
        }
      })
    );
  }
}
